import { Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { LoadingContainer } from 'app/components/LoadingContainer';
import StyledCollapse, {
  CollapsePanelWrapper,
} from 'app/components/StyledCollapse';
import StyledTable from 'app/components/StyledTable';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import * as _ from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { formatNumber, formatTimeFrame } from 'utils/helper';
import useScrollIntoElement from 'utils/hooks/useScrollIntoElement';
import useGetDetailTicket from '../../hooks/useGetDetailTicket';
import { Layout } from '../../layouts';
import { ACCOUNT_MNG_MENU } from '../../layouts/AccountManager';
import EmptyDataView from '../EmpyDataView';
import { OrderInfoExchangeView, getDateValidNormal } from '../helper';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import { DateFromToUtils } from 'utils/date-utils/date-utils';
import { DateFormat } from 'utils/date-utils/date-format';
import { FormatType } from 'utils/date-utils/types';
import moment from 'moment';
import RenderIf from 'app/components/RenderIf';
const DetailExchangeTicket = () => {
  const translations = useSelector(selectTranslations);
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const { locale } = useGlobalFunction();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const prevScreen = searchParams.get('prevScreen');
  const isFromEmail = useRef(searchParams.get('fromEmail') === 'true');
  const [screen, setScreen] = useState<string>();
  const { id }: { id: string } = useParams();
  const [loadingPage, setLoadingPage] = useState<boolean>(false);
  const [ticketNew, setTicketNew] = useState<any>();
  const formatString = 'HH:mm DD/MM/YYYY';
  const history = useHistory();
  const { onClickShowDetail: onClickShowToDetail, getDetailTicket } =
    useGetDetailTicket({
      screen: '/check-tickets',
    });

  const giftsAnchorTable = useRef<HTMLDivElement>(null);
  const ticketListPrevAnchorTable = useRef<HTMLDivElement>(null);
  const ticketListExchangeAnchorTable = useRef<HTMLDivElement>(null);
  const listCustomerAnchorTable = useRef<HTMLDivElement>(null);
  const dateFormatBuilder = useMemo(() => {
    return ({
      dateFrom,
      dateTo,
    }: {
      dateFrom: { format: FormatType; dateString: string };
      dateTo: { format: FormatType; dateString: string };
    }) =>
      new DateFromToUtils.Builder(locale, 'DD/MM/YYYY')
        .setFromDate(
          dateFrom.dateString
            ? moment(dateFrom.dateString, dateFrom.format)
            : undefined,
        )
        .setToDate(
          dateTo.dateString
            ? moment(dateTo.dateString, dateTo.format)
            : undefined,
        )
        .build();
  }, [locale]);

  const { onScrollIntoElement: onScrollIntoElementGifts } =
    useScrollIntoElement({
      elementRef: giftsAnchorTable,
    });
  const { onScrollIntoElement: onScrollIntoElementTicketListPrev } =
    useScrollIntoElement({
      elementRef: ticketListPrevAnchorTable,
    });
  const { onScrollIntoElement: onScrollIntoElementTicketListExchange } =
    useScrollIntoElement({
      elementRef: ticketListExchangeAnchorTable,
    });
  const { onScrollIntoElement: onScrollIntoElementListCustomer } =
    useScrollIntoElement({
      elementRef: listCustomerAnchorTable,
    });

  useEffect(() => {
    const fetchDetailTicket = async () => {
      const ticket = await getDetailTicket(id);
      setTicketNew(ticket);
    };
    fetchDetailTicket();
  }, []);

  const handleRedirect = async (orderIdChanged: any) => {
    await onClickShowToDetail(orderIdChanged);
  };

  const flattenDetailTickets = (dataItems: any[]) => {
    let newTickets: any[] = [];
    if (dataItems.length > 0) {
      newTickets = dataItems.map((ticketItem: any) => ({
        ...ticketItem,
        vgsUsageDateTo:
          ticketItem?.tickets.length > 0
            ? ticketItem?.tickets[0]?.vgsUsageDateTo
            : null,
        vgsUsageDate:
          ticketItem?.tickets.length > 0
            ? ticketItem?.tickets[0]?.vgsUsageDate
            : null,
      }));
    }
    return newTickets;
  };

  const listCustomers = useMemo(() => {
    const ticketBuyer =
      ticketNew?.ticketsInfo?.flatMap(val => val.dataBuyer) ?? [];
    const giftBuyer = ticketNew?.giftsInfo?.flatMap(val => val.dataBuyer) ?? [];
    return [...ticketBuyer, ...giftBuyer];
  }, [ticketNew?.ticketsInfo, ticketNew?.giftsInfo]);

  const columnTicket = [
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations ? translations['b2b.ugrade.ticket-name'] : ''}
        </div>
      ),
      render: dataObject => {
        return (
          <div style={{ textAlign: 'left' }}>
            <TooltipParagraph
              ellipsis={{ rows: 2 }}
              style={{
                width: 140,
                // color: '#F8B117',
                // cursor: 'pointer',
                marginBottom: 0,
                textAlign: 'left',
              }}
            >
              {`${dataObject?.product?.name || ''}`}
            </TooltipParagraph>
          </div>
        );
      },
      key: '2',
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations ? translations['b2c.txt.park'] : ''}
        </div>
      ),
      render: dataObject => {
        return (
          <>
            <TooltipParagraph
              ellipsis={{ rows: 1 }}
              style={{
                maxWidth: 200,
                marginBottom: 0,
                textAlign: 'left',
              }}
            >
              {!_.isEmpty(dataObject?.park?.name)
                ? dataObject?.park?.name.trim()
                : ''}
            </TooltipParagraph>
          </>
        );
      },
      key: '4',
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations ? translations['b2b.txt.ticketType'] : ''}
        </div>
      ),
      render: dataObject => {
        return (
          <div style={{ textAlign: 'left' }}>
            <TooltipParagraph
              ellipsis={{ rows: 1 }}
              style={{
                width: 164,
                marginBottom: 0,
                textAlign: 'left',
              }}
            >
              {dataObject?.catalog?.name || ''}
            </TooltipParagraph>
          </div>
        );
      },
      key: '3',
    },
    {
      title: (
        <div style={{ display: 'flex', textAlign: 'left' }}>
          {translations ? translations['b2c.txt.date-use'] : ''}
        </div>
      ),
      render: dataObject => {
        const { fromDateString, toDateString } = dateFormatBuilder({
          dateFrom: dataObject?.vgsUsageDate
            ? {
                dateString: dataObject?.vgsUsageDate,
                format: 'YYYY-MM-DD HH:mm',
              }
            : {
                dateString: dataObject?.useDateFrom,
                format: 'HH:mm DD/MM/YYYY',
              },
          dateTo: {
            format: 'YYYY-MM-DD HH:mm',
            dateString: dataObject?.vgsUsageDateTo ?? '',
          },
        }).getDateFromTo();

        return (
          <div style={{ textAlign: 'left' }}>
            <RenderIf
              condition={fromDateString !== toDateString}
              fallback={<>{fromDateString}</>}
            >
              <>
                {fromDateString} - <br /> {toDateString}
              </>
            </RenderIf>
          </div>
        );
      },
      key: 'expiredDate.datetime',
    },
    {
      title: (
        <div style={{ textAlign: 'left', display: 'flex' }}>
          <div>
            {translations ? translations['b2b.txt.ticket-detail'] : ''}{' '}
          </div>
        </div>
      ),
      render: dataObject => {
        return (
          <div style={{ textAlign: 'left' }}>
            {dataObject?.materialType !== '9005' && (
              <>
                <Typography>{dataObject?.zone?.name || ''}</Typography>
                <Typography>{dataObject?.restaurant?.name || ''}</Typography>
                <Typography>
                  {formatTimeFrame(
                    dataObject?.product?.usedArea2Object?.label || '',
                  )}
                </Typography>
              </>
            )}
          </div>
        );
      },
      key: 'usageDate.datetime',
    },
    {
      title: (
        <div style={{ textAlign: 'right', display: 'flex' }}>
          <div>
            {translations ? translations['b2b.upgrade.ticket-amount'] : ''}{' '}
          </div>
        </div>
      ),
      render: dataObject => {
        return (
          <div style={{ textAlign: 'right' }}>{dataObject?.amount || 0}</div>
        );
      },
      key: 'usageDate.amount',
    },
    {
      title: (
        <div style={{ textAlign: 'right' }}>
          {translations?.['b2b.txt.unitPrice']}
        </div>
      ),
      key: 'orderInfo.priceValue',
      render: orderInfo => (
        <div style={{ textAlign: 'right' }}>
          {formatNumber(orderInfo?.price) + 'đ'}
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'right', display: 'flex' }}>
          <div>{translations ? translations['b2b.txt.total-amount'] : ''} </div>
        </div>
      ),
      render: dataObject => {
        return (
          <div style={{ textAlign: 'right' }}>
            {formatNumber(dataObject?.totalPrice) + 'đ'}
          </div>
        );
      },
      key: 'usageDate.totalPrice',
    },
  ];

  const columnsCustomer: ColumnsType = useMemo(
    () => [
      {
        title: <div style={{ textAlign: 'left' }}>Email</div>,
        key: 'email',
        render: dataObject => {
          return (
            <div style={{ textAlign: 'left' }}>{dataObject?.email ?? ''}</div>
          );
        },
      },
      {
        title: (
          <div style={{ textAlign: 'left' }}>
            {translations ? translations['b2c.txt.identityCard'] : ''}
          </div>
        ),
        key: 'identityCard',
        render: dataObject => {
          return (
            <div style={{ textAlign: 'left' }}>
              {dataObject?.identityCode ?? ''}
            </div>
          );
        },
      },
    ],
    [translations],
  );

  useEffect(() => {
    if (prevScreen)
      history.replace(location.pathname, { screen: `/${prevScreen}` });
  }, [history, location.pathname, prevScreen]);

  useEffect(() => {
    // orderState: "cancelled", payment: "BankTransfer"
    const historyState: any = location?.state;
    if (historyState?.screen) {
      setScreen(historyState?.screen);
    }
  }, [location?.state]);

  const menuActive = useMemo(() => {
    switch (screen) {
      case '/account':
        return ACCOUNT_MNG_MENU.PURCHASE_HISTORY;
      case '/agent/transaction-history?screen=transaction-list':
      case '/agent/transaction-history':
        return ACCOUNT_MNG_MENU.AGENT_HISTORY;
      default:
        return ACCOUNT_MNG_MENU.CHECK_TICKET;
    }
  }, [screen]);

  return (
    <Layout
      title={
        !ticketNew
          ? null
          : translations
          ? translations['b2b.txt.ticket-detail-exchange']
          : ''
      }
      menuActive={menuActive}
      useBackArrow
      onBack={() => {
        if (
          menuActive === ACCOUNT_MNG_MENU.PURCHASE_HISTORY &&
          isFromEmail.current
        )
          history.replace('/account');
        else if (_.isUndefined(history.goBack())) {
          history.push('/check-tickets');
        } else {
          history.goBack();
        }
      }}
    >
      <LoadingContainer loading={!ticketNew || loadingPage}>
        {ticketNew ? (
          <>
            <div>
              {ticketNew && (
                <OrderInfoExchangeView
                  ticket={ticketNew}
                  formatString={formatString}
                  isAbleCancelOrder={
                    ticketNew.orderState?.value === 'paymentPending'
                  }
                  onCancelOrderSuccess={() => {
                    onOpenDialogNoti({
                      onCloseDialog: () => {
                        onCloseDialogNoti();
                        history.push('/account', {
                          targetTab: 'tab-3',
                        });
                      },
                      type: 'SUCCESS',
                      isShow: true,
                      title: '',
                      content:
                        translations?.['b2b.txt.cancelOrderSuccess']?.replace(
                          '{orderCode}',
                          ticketNew.orderInfo.orderId,
                        ) ?? '',
                    });
                  }}
                />
              )}
              {ticketNew?.giftsInfo && ticketNew.giftsInfo.length > 0 && (
                <div>
                  <div>
                    <p
                      style={{
                        marginTop: 20,
                        marginBottom: 24,
                        fontSize: 16,
                        fontWeight: 600,
                      }}
                    >
                      {translations
                        ? `${
                            translations['b2c.txt.giftInOrder'] +
                            ' ' +
                            translations['b2c.txt.totalTicket']?.replace(
                              '${amount}',
                              ticketNew?.giftsInfo?.length > 0
                                ? ticketNew?.giftsInfo?.reduce(
                                    (acc, cur) => acc + cur.amount,
                                    0,
                                  )
                                : 0,
                            )
                          }`
                        : ''}
                    </p>
                  </div>
                  <div>
                    <div ref={giftsAnchorTable} />
                    <StyledTable
                      dataSource={flattenDetailTickets(
                        ticketNew?.giftsInfo || [],
                      )}
                      columns={columnTicket}
                      tableProps={{
                        scroll: {
                          x: 'max-content',
                        },
                      }}
                      pagination={{
                        defaultPageSize: 20,
                        showSizeChanger: true,
                        pageSizeOptions: ['20', '50', '100'],
                        onChange: onScrollIntoElementGifts,
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div>
              <StyledCollapse
                expandIconPosition="end"
                defaultActiveKey={['1', '2']}
                ghost
              >
                <CollapsePanelWrapper
                  key="1"
                  header={
                    translations
                      ? `${
                          translations['b2b.txt.listTicketPrevious'] +
                          ' ' +
                          translations['b2c.txt.totalTicket']?.replace(
                            '${amount}',
                            ticketNew?.ticketBlocks?.length > 0
                              ? ticketNew?.ticketBlocks?.reduce(
                                  (acc, cur) => acc + cur.amount,
                                  0,
                                )
                              : 0,
                          )
                        }`
                      : ''
                  }
                >
                  <div ref={ticketListPrevAnchorTable} />
                  <StyledTable
                    dataSource={flattenDetailTickets(
                      ticketNew?.ticketBlocks || [],
                    )}
                    columns={columnTicket}
                    pagination={{
                      defaultPageSize: 20,
                      showSizeChanger: true,
                      pageSizeOptions: ['20', '50', '100'],
                      onChange: onScrollIntoElementTicketListPrev,
                    }}
                    tableProps={{
                      scroll: {
                        x: 'max-content',
                      },
                      locale: {
                        emptyText: (
                          <EmptyDataView
                            message={
                              translations
                                ? translations['b2b.txt.no-data-check-tickets']
                                : ''
                            }
                          />
                        ),
                      },
                    }}
                  />
                </CollapsePanelWrapper>
                <CollapsePanelWrapper
                  key="2"
                  header={
                    translations
                      ? `${
                          translations['b2b.txt.list-ticket-new'] +
                          ' ' +
                          translations['b2c.txt.totalTicket']?.replace(
                            '${amount}',
                            ticketNew?.ticketsInfo?.length > 0
                              ? ticketNew?.ticketsInfo?.reduce(
                                  (acc, cur) => acc + cur.amount,
                                  0,
                                )
                              : 0,
                          )
                        }`
                      : ''
                  }
                >
                  <div ref={ticketListExchangeAnchorTable} />
                  <StyledTable
                    dataSource={flattenDetailTickets(
                      ticketNew?.ticketsInfo || [],
                    )}
                    columns={columnTicket}
                    pagination={{
                      defaultPageSize: 20,
                      showSizeChanger: true,
                      pageSizeOptions: ['20', '50', '100'],
                      onChange: onScrollIntoElementTicketListExchange,
                    }}
                    tableProps={{
                      // TablePaginationConfig
                      scroll: {
                        x: 'max-content',
                      },
                      locale: {
                        emptyText: (
                          <EmptyDataView
                            message={
                              translations
                                ? translations['b2b.txt.no-data-check-tickets']
                                : ''
                            }
                          />
                        ),
                      },
                    }}
                  />
                </CollapsePanelWrapper>
              </StyledCollapse>
            </div>
          </>
        ) : null}
        {listCustomers.length > 0 && (
          <>
            <div className="mt-1 mb-4">
              <span
                style={{
                  fontWeight: 600,
                  fontSize: 16,
                  fontFamily: 'Be Vietnam Pro, sans-serif',
                }}
              >
                {translations ? translations['b2b.txt.listCustomer'] : ''}
              </span>
            </div>
            <div ref={listCustomerAnchorTable} />
            <StyledTable
              dataSource={
                (listCustomers?.filter(
                  val => Boolean(val?.email) || val?.identityCode,
                ) ?? []) as object[]
              }
              columns={columnsCustomer as object[]}
              pagination={{
                defaultPageSize: 20,
                showSizeChanger: true,
                pageSizeOptions: ['20', '50', '100'],
                onChange: onScrollIntoElementListCustomer,
              }}
              styleSlots={{
                td: {
                  padding: '15px 10px',
                },
              }}
              // tableProps={rowKey:(record, index) => `${(record as TicketType)._id}${index}`}
            />
          </>
        )}
      </LoadingContainer>
    </Layout>
  );
};
export default DetailExchangeTicket;
